import React, {FC} from 'react';
import {
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from '@mui/material';

export interface SearchResultItem {
  id: string | number;
  text: string;
  selected?: boolean;
  disabled?: boolean;
}

interface SearchBarResultsProps {
  items: SearchResultItem[];
  onItemSelect?: (item: SearchResultItem) => void;
  maxHeight?: number;
}

const SearchBarResults: FC<SearchBarResultsProps> = ({
  items,
  onItemSelect,
  maxHeight = 300,
}) => {
  if (!items || items.length === 0) return null;

  return (
    <Paper
      sx={{
        position: 'absolute',
        width: '100%',
        top: '100%',
        left: 0,
        mt: 1,
        zIndex: 1000,
        maxHeight,
        overflowY: 'auto',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
      }}
    >
      <List sx={{p: 0}}>
        {items.map(item => (
          <ListItem
            key={item.id}
            data-testid={`search-result-${item.id}`}
            dense
            button
            onClick={() => !item.disabled && onItemSelect && onItemSelect(item)}
            sx={
              item.disabled
                ? {opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'none'}
                : {
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }
            }
          >
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={item.selected ?? false}
                tabIndex={-1}
                disableRipple
                disabled={item.disabled ?? false}
              />
            </ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default SearchBarResults;
